var _path, _path2, _rect, _rect2, _rect3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayout12 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 90 160"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  d: "M0 0h90v160H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M6 18h78v15H6zM6 86h78v15H6z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 6,
  x: 29,
  y: 6,
  fill: "#CCC",
  rx: 3
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 6,
  x: 68,
  y: 6,
  fill: "#CCC",
  rx: 3
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 6,
  x: 6,
  y: 6,
  fill: "#CCC",
  rx: 3
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M6 35h78v15H6zM6 103h78v15H6zM6 52h78v15H6zM6 120h78v15H6zM6 69h78v15H6zM6 137h78v15H6z"
})));
export { SvgLayout12 as ReactComponent };